export const APP_PERMISSION = {
  'buy': 'buy_only',
  'manange': 'manage_only',
  'buyAndManange': 'buy_and_manage',
  'addp_fullControl': 'FULL',
  'addp_partialControl': 'PARTIAL',
  'addp_viewOnly': 'READ_ONLY',
  'addp_none': 'NONE'
};
